var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chart',{staticClass:"echart",attrs:{"option":_vm.option,"autoresize":true}})}
var staticRenderFns = []

export { render, staticRenderFns }